__turbopack_context__.v({
  "pixel": "PixelGridLoader-module__AnCDGW__pixel",
  "pixel-on": "PixelGridLoader-module__AnCDGW__pixel-on",
});
